import React from 'react';
import classnames from 'classnames';
import {FeedbackTriggerType} from 'records/FeedbackTrigger';
import TriggerIconButton from 'components/triggers/TriggerIconButton';
import ListensContextSelectContainer from 'components/triggers/rule-context/ListensContextSelectContainer';
import {CogIcon} from '@components/icon/CogIcon';
import {CircleXIcon} from '@components/icon/CircleXIcon';

export default class ListensContextView extends React.Component {
  constructor(props) {
    super(props);

    this.toggleSelection = this.toggleSelection.bind(this);
    this.cancelSelection = this.cancelSelection.bind(this);
    this.saveSelection = this.saveSelection.bind(this);

    this.removeItem = this.removeItem.bind(this);

    this.state = {
      selectionVisible: false,
      previousContext: null,
    };
  }

  componentDidMount() {
    this.setState({
      previousContext: this.props.context,
    });
  }

  removeItem() {
    this.setState({
      selectionVisible: false,
      previousContext: null,
    });
    this.props.removeItem();
  }

  saveSelection() {
    this.setState({
      previousContext: this.props.context,
      selectionVisible: false,
    });
  }

  cancelSelection() {
    this.setState({selectionVisible: false});
    if (!this.state.previousContext || !this.state.previousContext.range) {
      this.props.removeItem();
    } else {
      this.props.valueChange(this.state.previousContext.range);
    }
  }

  toggleSelection() {
    if (!this.props.context || !this.props.context.range) {
      this.props.addItem();
    }
    this.setState({
      selectionVisible: !this.state.selectionVisible,
    });
  }

  render() {
    const {context} = this.props;

    const showButton = !context || (context.type === FeedbackTriggerType.LISTENS && !context.range);

    return (
      <div className={classnames(!showButton && 'feedback-rule-type-select', 'feedback-option')}>
        <div className="rule-context">
          <div className="listen-context-view">
            {showButton && (
              <TriggerIconButton
                active={this.state.selectionVisible}
                label={'Optional: Specify percentage listened to'}
                onClick={this.toggleSelection}
                icon={<CogIcon tooltip="Edit" />}
              />
            )}
            {!showButton && (
              <div className="rule-option-list">
                <ul>
                  <li>
                    <div className="context-item">
                      <span className="condition-action" onClick={this.toggleSelection}>
                        they listened to{' '}
                        {context.range.start === context.range.end
                          ? `${context.range.start}% of the call`
                          : `between ${context.range.start}% and ${context.range.end}% of the call`}
                      </span>
                    </div>
                    <div className="delete" onClick={this.removeItem}>
                      <CircleXIcon tooltip="Remove" />
                    </div>
                  </li>
                </ul>
              </div>
            )}
            {this.state.selectionVisible && (
              <div className="create-rule-popout">
                <ListensContextSelectContainer
                  {...this.props}
                  saveSelection={this.saveSelection}
                  cancelSelection={this.cancelSelection}
                  closeRequest={this.cancelSelection}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
